import React from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { printElement, receiptPageCss, a4PageCss } from "@/lib/print";
import { RECEIPT_DEFAULTS, INVOICE_DEFAULTS, FISCAL_DEFAULTS, mergeTpl } from "@/lib/printTemplates";
import { ReceiptDoc, receiptFromOrder } from "@/components/print/ReceiptDoc";
import { InvoiceDoc } from "@/components/print/InvoiceDoc";
import { sendFiscalReceipt } from "@/lib/fiscal";

export const loadConfig = async (key, defaults) => {
  const { data } = await api.get(`/config/${key}`);
  return defaults ? mergeTpl(defaults, data) : data;
};

export const printReceiptData = (tpl, data) =>
  printElement(<ReceiptDoc tpl={tpl} data={data} />, { pageCss: receiptPageCss(tpl), title: "receipt" });

export async function printOrderReceipt(order, opts = {}) {
  const tpl = await loadConfig("print_receipt", RECEIPT_DEFAULTS);
  return printReceiptData(tpl, receiptFromOrder(order, opts));
}

// Final receipt after payment: fiscal device if enabled, otherwise the non-fiscal thermal receipt.
export async function printPaidReceipt(order) {
  const fiscal = { ...FISCAL_DEFAULTS, ...(await loadConfig("fiscal")) };
  if (fiscal.enabled && fiscal.printer_id) {
    try {
      await sendFiscalReceipt(fiscal, order);
      toast.success("Фискалният бон е отпечатан");
      return;
    } catch (e) {
      toast.error(`Фискалното устройство не отговаря: ${e.message}. Отпечатан е служебен бон.`);
    }
  }
  return printOrderReceipt(order);
}

export const invoiceTpl = (inv, saved) => mergeTpl(INVOICE_DEFAULTS, inv?.template && Object.keys(inv.template).length ? inv.template : saved);

export const printInvoice = (tpl, inv) =>
  printElement(<InvoiceDoc tpl={tpl} inv={inv} />, { pageCss: a4PageCss(), title: `invoice-${inv.number_str}` });

export async function downloadInvoicePdf(tpl, inv) {
  const html2pdf = (await import("html2pdf.js")).default;
  const holder = document.createElement("div");
  Object.assign(holder.style, { position: "fixed", left: "-10000px", top: "0" });
  document.body.appendChild(holder);
  const { createRoot } = await import("react-dom/client");
  const root = createRoot(holder);
  root.render(<InvoiceDoc tpl={tpl} inv={inv} />);
  await new Promise((r) => setTimeout(r, 400));
  try {
    await html2pdf().set({ margin: 0, filename: `invoice-${inv.number_str}.pdf`, image: { type: "jpeg", quality: 0.96 },
      html2canvas: { scale: 2, useCORS: true }, jsPDF: { unit: "mm", format: "a4", orientation: "portrait" } }).from(holder.firstChild).save();
  } finally { root.unmount(); holder.remove(); }
}
